module.exports = "h1 {\n  color: #8486AF;\n  font-size: 25px;\n  font-weight: 500; }\n"